import React, { useState, useEffect } from "react";
import { FaSearch } from "react-icons/fa";
import { Modal } from "react-bootstrap";
import axios from "axios";
import { toast } from "react-toastify";
import PdfViewer from "../../paginas/pdf/View";
import { URL_EMPLOYEE } from "../../constans/servidor";

const InvoicePointService = ({ filteredData }) => {
  const [open, setOpen] = useState(false);
  const [loadingRow, setLoadingRow] = useState(null);
  const [base64, setBase64] = useState("");
  const [invoice, setInvoice] = useState("");

  let extractNit = (nit) => {
    const index = nit.indexOf("-");
    const numero = nit.substring(index + 1); // "222222222222"
    return numero;
  };

  const handleSearchClick = async (row) => {
    try {
      setLoadingRow(row.numFacturaSAP);
      const response = await axios.post(
        `${URL_EMPLOYEE}/parkingInvoiceOne/graphicalRepresentation`,
        { numberInvoice: row.numFacturaSAP, prefijo: 'FV' }
      );

      if (response.data.status) {
        if (response.data.pdf64 === "No existe PDF") {
          toast.error(response.data.pdf64);
          setLoadingRow(null);
          return;
        } else {
          toast.success(response.data.message);
          setInvoice(row.numFacturaSAP);
          setBase64(response.data.pdf64);
          setLoadingRow(null);
          setOpen(true);
        }
      } else {
        toast.error(response.data.message);
        toast.error("La factura aun no se ha transmitido a la DIAN")
        setLoadingRow(null);
      }
    } catch (error) {
      setLoadingRow(null);
      toast.error("Ocurrió un error al buscar la información.");
      console.error("Error al consumir el servicio:", error);
    }
  };

  return (
    <>
      {filteredData ? (
        <>
          <table className="tabla">
            <thead>
              <tr>
                <th>Documento</th>
                <th>Placa</th>
                <th>Comprobante</th>
                <th>Factura Electronica</th>
                <th>Parqueadero</th>
                <th>Terminal</th>
                <th>Fecha</th>
                <th>Total</th>
                <th>Representación Grafica</th>
              </tr>
            </thead>
            <tbody>
              {filteredData.map((row, index) => (
                <tr key={index}>
                  <td>{extractNit(row.identificacion)}</td>
                  <td>
                    {row.placa !== "null" &&
                      row.placa !== "" &&
                      row.placa !== "0"
                      ? row.placa
                      : "Placa no reconocida"}
                  </td>
                  <td>{row.numFacturaSIP}</td>
                  <td>
                    {row.numFacturaSAP === ""
                      ? "A la espera envio a SAP"
                      : row.numFacturaSAP}
                  </td>
                  <td>{row.cod_park}</td>
                  <td>{row.cod_terminal}</td>
                  <td>{row.fecha_final}</td>
                  <td>{row.total}</td>
                  <td>
                    {row.numFacturaSAP ? (
                      <>
                        {loadingRow === row.numFacturaSAP ? (
                          <div className="container-sniper"></div>
                        ) : (
                          <FaSearch
                            style={{ cursor: "pointer", color: "#008b9c" }}
                            onClick={() => handleSearchClick(row)}
                          />
                        )}
                      </>
                    ) : (
                      <>A la espera envio a la DIAN</>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          {base64 ? (
            <Modal show={open} onHide={() => setOpen(false)}>
              <Modal.Header closeButton>
                <Modal.Title style={{ color: "#008b9c" }}>
                  Representación Grafica
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <PdfViewer base64String={base64} invoice={invoice} />
              </Modal.Body>
            </Modal>
          ) : null}
        </>
      ) : null}
    </>
  );
};

export default InvoicePointService;
